import { useQuery } from "@tanstack/react-query";
import PageService from "services/PageService";
import { pagesQueryKeys } from "./keys";
import ProjectService from "services/ProjectService";

export const usePagesListQuery = (projectId) => {
    return useQuery({
        queryKey: [pagesQueryKeys.pagesList, projectId],
        queryFn: () => PageService.getAllPagesByProjectId(projectId),
        enabled: !!projectId,
    });
}

export const useProjectSiteMap = (projectId) => {
    return useQuery({
        queryKey: [pagesQueryKeys.siteMapList, projectId],
        queryFn: () => ProjectService.getProjectSitemapByProjectId(projectId),
        enabled: !!projectId,
    });
}